import React, { Component } from "react";
import "./LimitComponents.scss";

export const LimitMessage = ({ message, totalCount, usedCount, limitReached, packageObj }) => {
    if (totalCount === -1) return null;
    return <span className={`limit-message ${limitReached || totalCount <= usedCount ? "limit-message-reached" : "limit-message-available"}`}>{message}</span>;
};
